<div class="main-content">
	<div class="container-fluid">
		<mat-card class="feature-surface">
			<mat-card-header>
				<div mat-card-avatar class="feature-surface__icon">
					<i class="material-icons" aria-hidden="true">event_available</i>
				</div>
				<mat-card-title>Warehouse Visits</mat-card-title>
				<mat-card-subtitle>
					Who is coming to the warehouse and when — confirm pickup requests, block time off, publish the hours brands can book into
				</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>

				<div class="wv-toolbar">
					<mat-form-field appearance="outline" class="wv-toolbar__loc">
						<mat-label>Warehouse</mat-label>
						<mat-select [(ngModel)]="loccode" (selectionChange)="onLocation()">
							<mat-option value="">All warehouses</mat-option>
							<mat-option *ngFor="let l of locations" [value]="l.loccode">{{ l.locationname }}</mat-option>
						</mat-select>
					</mat-form-field>

					<div class="wv-toolbar__week">
						<button mat-icon-button (click)="prevWeek()" aria-label="Previous week">
							<i class="material-icons" aria-hidden="true">chevron_left</i>
						</button>
						<span class="wv-toolbar__label">{{ weekLabel }}</span>
						<button mat-icon-button (click)="nextWeek()" aria-label="Next week">
							<i class="material-icons" aria-hidden="true">chevron_right</i>
						</button>
						<button mat-stroked-button color="accent" (click)="thisWeek()" [disabled]="isThisWeek">Today</button>
					</div>

					<div class="wv-toolbar__actions">
						<button mat-stroked-button (click)="toggleHours()">
							{{ showHours ? 'Hide hours' : 'Published hours' }}
						</button>
						<button mat-flat-button color="accent" (click)="openBlock()">Block time</button>
					</div>
				</div>

				<div *ngIf="message" class="wv-flash" [class.is-ok]="messageOk" role="status">{{ message }}</div>

				<!-- Pending pickup requests. Above the grid on purpose: a request
				     nobody answers is somebody who turns up anyway. -->
				<div *ngIf="requests.length" class="feature-section wv-requests">
					<p class="feature-section__title">Waiting on a time · {{ requests.length }}</p>
					<span class="feature-section__hint">
						A pickup request records a preferred time only — it holds no capacity until you confirm one.
					</span>
					<div class="wv-requests__rail">
						<button type="button" class="wv-chip" *ngFor="let r of requests"
							[class.is-selected]="selected?.visit_id === r.visit_id" (click)="select(r)">
							<span class="wv-chip__name">{{ r.party_name }}</span>
							<span class="wv-chip__when">{{ r.day_label }} · {{ r.time_label }}</span>
							<span class="wv-chip__meta">{{ r.party_label }}<span *ngIf="r.contact_name"> · {{ r.contact_name }}</span></span>
						</button>
					</div>
				</div>

				<div *ngIf="loading" class="text-center my-4">
					<mat-progress-spinner diameter="32" mode="indeterminate" color="accent"></mat-progress-spinner>
				</div>

				<!-- Week grid -->
				<div class="wv-scroll" *ngIf="!loading">
					<div class="wv-cal" [style.--wv-hours]="hourMarks.length">

						<div class="wv-head">
							<div class="wv-head__gutter"></div>
							<div class="wv-dayhead" *ngFor="let d of days"
								[class.is-today]="d.isToday" [class.is-past]="d.isPast" [class.is-weekend]="d.isWeekend">
								<span class="wv-dayhead__dow">{{ d.dow }}</span>
								<span class="wv-dayhead__num">{{ d.daynum }}</span>
								<span class="wv-dayhead__meta">
									<ng-container *ngIf="d.openSlots">{{ d.openSlots }} open</ng-container>
									<ng-container *ngIf="!d.openSlots && d.visitCount">{{ d.visitCount }} booked</ng-container>
									<ng-container *ngIf="!d.openSlots && !d.visitCount && d.bands.length">&mdash;</ng-container>
									<ng-container *ngIf="!d.openSlots && !d.visitCount && !d.bands.length">closed</ng-container>
								</span>
							</div>
						</div>

						<div class="wv-allday" *ngIf="hasAllday">
							<div class="wv-allday__gutter">All day</div>
							<div class="wv-allday__cell" *ngFor="let d of days" [class.is-today]="d.isToday">
								<button type="button" class="wv-adchip" *ngFor="let v of d.allday"
									[class.is-blackout]="v.is_blackout" (click)="select(v)">{{ v.party_name }}</button>
							</div>
						</div>

						<div class="wv-body">
							<div class="wv-gutter">
								<div class="wv-gutter__hour" *ngFor="let h of hourMarks"><span>{{ h.label }}</span></div>
							</div>

							<div class="wv-col" *ngFor="let d of days"
								[class.is-today]="d.isToday" [class.is-past]="d.isPast" [class.is-weekend]="d.isWeekend">

								<div class="wv-band" *ngFor="let b of d.bands"
									[style.top.%]="b.top" [style.height.%]="b.height" [title]="b.label"></div>

								<!-- Click an hour to block it. Every cell is a real button so
								     the gesture works from the keyboard too. -->
								<button type="button" class="wv-cell" *ngFor="let h of hourMarks; let i = index"
									[style.top.%]="i / hourMarks.length * 100"
									[style.height.%]="100 / hourMarks.length"
									(click)="onCellClick(d, h)"
									[attr.aria-label]="'Block ' + h.label + ' on ' + d.dow + ' ' + d.daynum"></button>

								<div class="wv-now" *ngIf="d.isToday && nowPct >= 0" [style.top.%]="nowPct">
									<span>{{ clock(nowPct * gridSpan / 100 + gridStart) }}</span>
								</div>

								<button type="button" class="wv-ev" *ngFor="let e of d.events"
									[ngClass]="'wv-ev--' + e.v.status"
									[class.is-short]="e.short" [class.is-tiny]="e.tiny"
									[class.is-clip-top]="e.clipTop" [class.is-clip-bottom]="e.clipBottom"
									[class.is-selected]="selected?.visit_id === e.v.visit_id"
									[style.top.%]="e.top" [style.height.%]="e.height"
									[style.left.%]="e.left" [style.width.%]="e.width"
									[title]="e.v.time_label + ' · ' + e.v.party_name + ' · ' + e.v.status_label"
									(click)="select(e.v)">
									<span class="wv-ev__bar" aria-hidden="true"></span>
									<span class="wv-ev__text">
										<span class="wv-ev__name">{{ e.v.party_name }}</span>
										<span class="wv-ev__time">{{ e.v.time_short }}<ng-container *ngIf="!e.short"> · {{ e.v.kind_label }}</ng-container></span>
									</span>
								</button>
							</div>
						</div>

					</div>
				</div>

				<div class="wv-legend" *ngIf="!loading">
					<span class="wv-key"><i class="wv-key__band"></i>Open hours</span>
					<span class="wv-key"><i class="wv-key__dot wv-key__dot--scheduled"></i>Confirmed</span>
					<span class="wv-key"><i class="wv-key__dot wv-key__dot--requested"></i>Requested</span>
					<span class="wv-key"><i class="wv-key__dot wv-key__dot--completed"></i>Came</span>
					<span class="wv-key"><i class="wv-key__dot wv-key__dot--no_show"></i>No show / declined</span>
					<span class="wv-key"><i class="wv-key__dot wv-key__dot--blackout"></i>Blocked</span>
				</div>

				<!-- One visit. Inline rather than a dialog so the week stays visible
				     while you answer it. -->
				<div *ngIf="selected" class="feature-section mt-4">
					<div class="d-flex justify-content-between align-items-start mb-2">
						<div>
							<p class="feature-section__title m-0">{{ selected.party_name }}</p>
							<span class="feature-section__hint">
								<ng-container *ngIf="selected.is_pending">Asked for: </ng-container>{{ selected.day_label }} · {{ selected.time_label }}
							</span>
						</div>
						<div class="d-flex align-items-center" style="gap: 8px;">
							<app-status-pill [status]="tone(selected.status)" [label]="selected.status_label"></app-status-pill>
							<button mat-icon-button (click)="clearSelection()" aria-label="Close">
								<i class="material-icons">close</i>
							</button>
						</div>
					</div>

					<table class="feature-table feature-table--responsive wv-detail">
						<tbody>
							<tr>
								<td data-label="Who">{{ selected.party_label }}<span *ngIf="selected.party_key"> · {{ selected.party_key }}</span></td>
								<td data-label="Type">{{ selected.kind_label }}</td>
								<td data-label="Warehouse">{{ selected.location }}</td>
								<td data-label="Reason">{{ selected.reason_label }}</td>
							</tr>
							<tr>
								<td data-label="Who is coming">{{ selected.contact_name || '—' }}</td>
								<td data-label="Mobile">{{ selected.contact_phone || '—' }}</td>
								<td data-label="Vehicle">{{ selected.vehicle_info || '—' }}</td>
								<td data-label="Order">{{ selected.orderno ? selected.orderno : '—' }}</td>
							</tr>
							<tr *ngIf="selected.notes || selected.decision_note || selected.decided_by">
								<td data-label="They said" colspan="2"><span>{{ selected.notes || '—' }}</span></td>
								<td data-label="We said"><span>{{ selected.decision_note || '—' }}</span></td>
								<td data-label="Last touched by">{{ selected.decided_by || '—' }}</td>
							</tr>
						</tbody>
					</table>

					<!-- A blackout has no party to answer. -->
					<div *ngIf="selected.is_blackout" class="wv-actions mt-3">
						<button mat-stroked-button color="warn" [disabled]="saving" (click)="unblock()">Remove block</button>
					</div>

					<!-- A request has no confirmed time yet, so "came" and "no show"
					     would be answering a question nobody asked. -->
					<ng-container *ngIf="selected.is_pending">
						<p class="wv-subhead">Give it a time</p>
						<form [formGroup]="confirmForm" class="wv-form">
							<mat-form-field appearance="outline">
								<mat-label>Starts</mat-label>
								<input matInput type="datetime-local" formControlName="starts_at">
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>Ends</mat-label>
								<input matInput type="datetime-local" formControlName="ends_at">
							</mat-form-field>
							<mat-form-field appearance="outline" class="wv-form__wide">
								<mat-label>Message to the visitor</mat-label>
								<input matInput type="text" maxlength="255" formControlName="note">
							</mat-form-field>
							<div class="wv-actions wv-form__wide">
								<button mat-stroked-button color="warn" [disabled]="saving" (click)="decide('decline')">Decline</button>
								<button mat-flat-button color="accent" [disabled]="saving || !confirmForm.valid" (click)="decide('confirm')">
									{{ saving ? 'Saving…' : 'Confirm' }}
								</button>
							</div>
						</form>
					</ng-container>

					<div *ngIf="selected.is_scheduled" class="wv-actions mt-3">
						<button mat-stroked-button [disabled]="saving" (click)="mark('completed')">Came</button>
						<button mat-stroked-button [disabled]="saving" (click)="mark('no_show')">No show</button>
						<button mat-stroked-button color="warn" [disabled]="saving" (click)="mark('cancelled')">Cancel visit</button>
					</div>

					<p class="wv-subhead">Internal note</p>
					<div class="wv-form">
						<mat-form-field appearance="outline" class="wv-form__wide">
							<mat-label>Only the warehouse sees this</mat-label>
							<textarea matInput rows="2" [(ngModel)]="internalNote"></textarea>
						</mat-form-field>
						<div class="wv-actions wv-form__wide">
							<button mat-stroked-button [disabled]="saving" (click)="saveNote()">Save note</button>
						</div>
					</div>

					<ng-container *ngIf="selected.is_scheduled || selected.is_blackout">
						<p class="wv-subhead">Move it</p>
						<form [formGroup]="moveForm" class="wv-form">
							<mat-form-field appearance="outline">
								<mat-label>Starts</mat-label>
								<input matInput type="datetime-local" formControlName="starts_at">
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>Ends</mat-label>
								<input matInput type="datetime-local" formControlName="ends_at">
							</mat-form-field>
							<div class="wv-actions wv-form__wide">
								<button mat-flat-button color="accent" [disabled]="saving || !moveForm.valid" (click)="move()">Move</button>
							</div>
						</form>
					</ng-container>
				</div>

				<!-- Published hours. One readable line per schedule, with the weekdays
				     collapsed by the endpoint, and one editor behind Edit — five
				     identical rows of times, slot length and capacity was the problem. -->
				<div *ngIf="showHours" class="feature-section mt-4">
					<p class="feature-section__title">Published hours</p>
					<span class="feature-section__hint">The times brands and dispensaries can book a drop-off into.</span>

					<p *ngIf="!hasHours" class="wv-warn">
						No hours published — nobody can book a drop-off until you add some.
					</p>

					<div class="wv-sched">
						<div class="wv-sched__row" *ngFor="let g of weekly" [class.is-paused]="!g.active">
							<div class="wv-sched__when">
								<strong>{{ g.days_label }}</strong>
								<span>{{ g.hours_label }}</span>
							</div>
							<div class="wv-sched__how">
								<span>{{ g.slot_minutes }} min slots · {{ g.capacity }} at a time</span>
								<span>{{ g.location }} · {{ g.kind_label }}</span>
								<span *ngIf="!g.active" class="wv-sched__paused">Paused</span>
							</div>
							<button mat-stroked-button color="accent" (click)="editSchedule(g)">Edit</button>
						</div>

						<div class="wv-sched__row wv-sched__row--oneoff" *ngFor="let w of oneoffs">
							<div class="wv-sched__when">
								<strong>{{ w.when_label }}</strong>
								<span>{{ w.start_time }} – {{ w.end_time }}</span>
							</div>
							<div class="wv-sched__how">
								<span>{{ w.slot_minutes }} min slots · {{ w.capacity }} at a time</span>
								<span>{{ w.location }} · {{ w.kind_label }}</span>
							</div>
							<button mat-stroked-button color="warn" [disabled]="saving" (click)="deleteOneoff(w)">Delete</button>
						</div>
					</div>

					<div class="wv-sched__add">
						<button mat-stroked-button (click)="newSchedule('week')">Add hours</button>
						<button mat-stroked-button (click)="newSchedule('date')">Add a one-off day</button>
					</div>

					<div class="wv-editor" *ngIf="editing">
						<div class="wv-editor__head">
							<strong>{{ editTitle }}</strong>
							<button mat-icon-button (click)="cancelEdit()" aria-label="Close">
								<i class="material-icons">close</i>
							</button>
						</div>

						<div class="wv-days" *ngIf="editMode === 'week'">
							<span class="wv-days__label">Days open</span>
							<div class="wv-days__row">
								<button type="button" class="wv-day" *ngFor="let d of weekdayOptions"
									[class.is-on]="editDays[d.value]"
									[attr.aria-pressed]="editDays[d.value] ? 'true' : 'false'"
									(click)="toggleDay(d.value)">{{ d.short }}</button>
							</div>
						</div>

						<form [formGroup]="hoursForm" class="wv-form">
							<mat-form-field appearance="outline" *ngIf="editMode === 'date'">
								<mat-label>Date</mat-label>
								<input matInput type="date" formControlName="specific_date">
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>From</mat-label>
								<input matInput type="time" formControlName="start_time">
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>To</mat-label>
								<input matInput type="time" formControlName="end_time">
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>Slot length (min)</mat-label>
								<input matInput type="number" min="5" max="480" step="5" formControlName="slot_minutes">
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>Visits at a time</mat-label>
								<input matInput type="number" min="1" max="99" formControlName="capacity">
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>Warehouse</mat-label>
								<mat-select formControlName="loccode">
									<mat-option *ngFor="let l of locations" [value]="l.loccode">{{ l.locationname }}</mat-option>
								</mat-select>
							</mat-form-field>
							<mat-form-field appearance="outline">
								<mat-label>Applies to</mat-label>
								<mat-select formControlName="visit_kind">
									<mat-option value="dropoff">Drop-off</mat-option>
									<mat-option value="pickup">Pickup</mat-option>
									<mat-option value="any">Both</mat-option>
								</mat-select>
							</mat-form-field>
							<div class="wv-editor__foot wv-form__wide">
								<mat-checkbox formControlName="active">Published</mat-checkbox>
								<button mat-flat-button color="accent" [disabled]="saving || !hoursForm.valid" (click)="saveSchedule()">
									{{ saving ? 'Saving…' : 'Save' }}
								</button>
							</div>
						</form>
					</div>
				</div>

			</mat-card-content>
		</mat-card>
	</div>
</div>

<ng-template #blockDialog>
	<h2 mat-dialog-title>Block time off</h2>
	<form [formGroup]="blockForm" mat-dialog-content>
		<p class="text-muted">A block hides those slots from everyone and shows on the calendar.</p>
		<mat-form-field appearance="outline" class="w-100 mt-2">
			<mat-label>Warehouse</mat-label>
			<mat-select formControlName="loccode">
				<mat-option *ngFor="let l of locations" [value]="l.loccode">{{ l.locationname }}</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Label</mat-label>
			<input matInput type="text" maxlength="120" formControlName="title" placeholder="Stocktake">
		</mat-form-field>
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Starts</mat-label>
			<input matInput type="datetime-local" formControlName="starts_at">
		</mat-form-field>
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Ends</mat-label>
			<input matInput type="datetime-local" formControlName="ends_at">
		</mat-form-field>
	</form>
	<div mat-dialog-actions class="d-flex justify-content-end" style="gap: 8px;">
		<button mat-stroked-button mat-dialog-close>Cancel</button>
		<button mat-flat-button color="accent" [disabled]="saving || !blockForm.valid" (click)="saveBlock()">
			{{ saving ? 'Blocking…' : 'Block time' }}
		</button>
	</div>
</ng-template>
